import request from '@/utils/request'

// 地图配置列表
const login = data => {
  return request({
    url: '/login',
    method: 'POST',
    data
  })
}
// const login = query => {
//   return request({
//     url: '/api/item',
//     method: 'POST',
//     params: query
//   })
// }


export {
  login
}



// WEBPACK FOOTER //
// ./src/api/interface/login.js